import styled, { keyframes } from "styled-components";
import { theme } from "../../helpers/theme";

const show = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1
}`;

export const BackDrop: any = styled.div`
  background-color: ${theme.colors.gray04_background};
  animation-name: ${show};
  animation-duration: 0.25s;
  height: 100%;
  position: fixed;
  transition: all 1.3s;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${(props: any) => (props?.open ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;
